export function linkToUpdatePage() {
  return "/update";
}
